import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

// Ayarlar > Doküman Etiketleri sayfasi. Sirket-scoped CRUD; useTags pattern'i
// birebir. `documentBank_tags` yerine `document_bank_tags` (snake_case Hasura
// tablo adi) — gqlEntityKey Hasura insert/update/delete anahtarini turetiyor.
const useDocumentBankTags = () => {
  const { user } = useAuth();
  const dynamicHook = useDynamicEntity({
    entityType: 'documentBankTags',
    gqlEntityKey: 'document_bank_tags',
    queryName: 'GET_DOCUMENT_BANK_TAGS_QUERY',
    createMutation: 'CREATE_DOCUMENT_BANK_TAG_MUTATION',
    updateMutation: 'UPDATE_DOCUMENT_BANK_TAG_MUTATION',
    deleteMutation: 'DELETE_DOCUMENT_BANK_TAG_MUTATION',
    updateVariableName: 'set',
    transformData: (tag) => ({
      ...tag,
      company_name: tag.company?.name || `Company ${tag.company_id}`,
      companyId: tag.company_id,
    }),
    transformFormData: (formData) => ({
      name: (formData.name || '').trim(),
      color: formData.color || '#3b82f6',
      company_id: formData.companyId || user?.companyId,
    }),
    customWhereCondition:
      user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });
  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useDocumentBankTags };
